import {FormControl, FormField} from 'platform/components';
import {Grid, GridItem} from 'platform/foundation';

import i18n from '@dms/i18n';

import {FormValues} from '../../UserDetail/types/FormValues';

interface UserInfoProps {
  control: FormControl<FormValues>;
}

export function UserInfo(props: UserInfoProps) {
  return (
    <Grid columns={2}>
      <FormField
        control={props.control}
        type="text"
        name="firstName"
        label={i18n.t('general.labels.firstName')}
        isRequired
      />

      <FormField
        control={props.control}
        type="text"
        name="lastName"
        label={i18n.t('general.labels.lastName')}
        isRequired
      />

      <GridItem span={2}>
        <FormField
          control={props.control}
          type="text"
          name="email"
          label={i18n.t('general.labels.email')}
          isRequired
        />
      </GridItem>
    </Grid>
  );
}
